import { CustomerExperienceSettings } from './CustomerExperienceSettings'
import { CustomerHubSettings } from './CustomerHubSettings'
import { MobileSettings } from './MobileSettings'
import { MobileV2Settings } from './MobileV2Settings'
import { WebSettings } from './WebSettings'
import { WebModularSettings } from './WebModularSettings'

export default {
  mobile: MobileSettings,
  'mobile-v2': MobileV2Settings,
  web: WebSettings,
  'web-modular': WebModularSettings,
  'customer-experience': CustomerExperienceSettings,
  'customer-hub': CustomerHubSettings,
}
